import React, { useState } from "react";
import styled from "styled-components";
import MotorCertificateForm from "components/widgets/forms/setup/Motor_Certificate_Config";
import BasicDetails from "components/setup/BasicDetails";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { fetch_product_details } from "services/apiSrv";
import Loader from "components/widgets/loader";

// Styled Components
const Container = styled.div`
  padding: 24px;
  max-width: 100%;
  margin: 0 auto;
`;

const Title = styled.h1`
  font-size: 24px;
  margin-bottom: 16px;
  color: #333;

  @media (max-width: 768px) {
    font-size: 20px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

const TableWrapper = styled.div`
  overflow-x: auto;
  max-height: 60vh;
  overflow-y: auto;
  margin-bottom: 32px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 8px rgb(0 0 0 / 0.1);
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #ddd;
    font-size: 14px;
  }

  th {
    background: #f4f4f4;
    font-weight: 600;
    position: sticky;
    top: 0;
    z-index: 10;
  }

  @media (max-width: 768px) {
    th,
    td {
      padding: 8px;
      font-size: 12px;
    }
  }

  @media (max-width: 480px) {
    th,
    td {
      padding: 6px;
      font-size: 10px;
    }
  }
`;

const Section = styled.div`
  margin-bottom: 48px;
`;

export default function MotorCertificateConfigPage() {
  const { id: productSystemRef } = useParams();

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["productDetails", productSystemRef],
    queryFn: () => fetch_product_details(productSystemRef),
    enabled: !!productSystemRef,
    retry: 2,
    staleTime: 5 * 60 * 1000,
  });

  if (isLoading) {
    return <Loader />;
  }

  if (isError) {
    return <p>Error fetching product details: {error?.message || "Something went wrong"}</p>;
  }

  if (!data?.data) {
    return <p>No product data available.</p>;
  }

  const { productCertificateConfig } = data.data[0];

  let config = {};
  if(!!productCertificateConfig){
  if (productCertificateConfig.motorCertifcateConfigType === "manual") {
    config.name = "Manual";
    config.type = "manual";
  } else if (productCertificateConfig.motorCertifcateConfigType === "auto") {
    config.name = "Auto";
    config.type = "auto";
    config.category = productCertificateConfig.dmvicCategory;
    config.subcategory = productCertificateConfig.dmvicSubcategory;
    config.certificateIssuing = productCertificateConfig.certificateIssuing;
    config.motorCertifcateConfigDoublevalidation = productCertificateConfig.motorCertifcateConfigDoublevalidation;
    config.motorCertifcateConfigIssuer = productCertificateConfig.motorCertifcateConfigIssuer;
    config.onCertificateFailure = productCertificateConfig.onCertificateFailure;
  }
  }


  return (
    <Container>
      {/* Basic Details Section */}
      <BasicDetails />

      {/* Motor Certificate Form Section */}
      <Section>
        <Title>Motor Certificate Issuance</Title>
        <MotorCertificateForm refetchProductDetails={refetch} />
      </Section>

      {/* Config Properties Table Section */}
      {config && (
      <Section>
        <Title>Configuration Details</Title>
        <TableWrapper>
          <Table>
            <thead>
              <tr>
                <th>Property</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Name</td>
                <td>{config.name || "N/A"}</td>
              </tr>
              <tr>
                <td>Type</td>
                <td>{config.type || "N/A"}</td>
              </tr>
              {config.type === "auto" && (
                <>
                  <tr>
                    <td>Category</td>
                    <td>{config.category || "N/A"}</td>
                  </tr>
                  <tr>
                    <td>Subcategory</td>
                    <td>{config.subcategory || "N/A"}</td>
                  </tr>
                  <tr>
                    <td>Certificate Issuing</td>
                    <td>{config.certificateIssuing || "N/A"}</td>
                  </tr>
                  <tr>
                    <td>Double Validation</td>
                    <td>{config.motorCertifcateConfigDoublevalidation ? "Enabled" : "Disabled"}</td>
                  </tr>
                  <tr>
                    <td>Issuer</td>
                    <td>{config.motorCertifcateConfigIssuer || "N/A"}</td>
                  </tr>
                  <tr>
                    <td>On Certificate Failure</td>
                    <td>{config.onCertificateFailure || "N/A"}</td>
                  </tr>
                </>
              )}
            </tbody>
          </Table>
        </TableWrapper>
      </Section>
      )}

    </Container>
  );
}